import React from 'react'

export function AccentText({ children }) {
    return <span className="accent">{children}</span>
}
